module.exports = __webpack_public_path__ + "media/images/sp/top/kodawari_maedori-bedf1e71ae053dd6283054c12bf42997.webp";